import { render, staticRenderFns } from "./DecretosNewOrEdit.vue?vue&type=template&id=fa404694&scoped=true&"
import script from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DecretosNewOrEdit.vue?vue&type=style&index=0&id=fa404694&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa404694",
  null
  
)

export default component.exports